/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const CredentialVerify: core.serialization.ObjectSchema<
    serializers.CredentialVerify.Raw,
    Truvity.CredentialVerify
> = core.serialization.object({
    verified: core.serialization.boolean(),
});

export declare namespace CredentialVerify {
    export interface Raw {
        verified: boolean;
    }
}
